import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

import fullDealsTag from "./fragments/fullDealsTag"
import fullDeal from "./fragments/fullDeal"
import fullDealCategory from "./fragments/fullDealCategory"

const query = gql`
  query getHomepage($lat: Float, $lng: Float, $radius: Int) {
    homepageDealCategories {
      results {
        ...fullDealCategory
      }
    }
    homepageBanners {
      ...fullDeal
    }
    homepageBirthdayBanner {
      ...fullDeal
    }
    homepageLanes(lat: $lat, lng: $lng, radius: $radius) {
      results {
        linkedEntityUrl
        type
        headerText
        bodyText
        deals {
          ...fullDeal
        }
        tag {
          ...fullDealsTag
        }
        image
      }
    }
  }
  ${fullDealCategory}
  ${fullDealsTag}
  ${fullDeal}
`
export const toString = query.loc.source.body

export const stockJobListKey = getQueryNames(query)[0]

export default query
